import { graphql, useStaticQuery } from "gatsby";
import { SEOProps } from "../types/types";

function useSEO({ title, description, imageUrl, pathname }: SEOProps) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          image
        }
      }
    }
  `);

  return {
    title: title
      ? `${title} | ${site.siteMetadata.title}`
      : site.siteMetadata.title,
    description: description || site.siteMetadata.description,
    image: imageUrl
      ? `${site.siteMetadata.siteUrl}${imageUrl}`
      : `${site.siteMetadata.siteUrl}${site.siteMetadata.image}`,
    url: `${site.siteMetadata.siteUrl}${pathname || "/"}`,
  };
}

export default useSEO;
